import React, { InputHTMLAttributes } from "react"
import cn from "classnames"
import ReactSlider from "react-slider"

export type TrackVariant = "curiousBlueOnWhite" | "range";

interface SliderProps {
  className?: string;
  input: InputHTMLAttributes<HTMLInputElement>;
  max: number;
  min: number;
  range?: boolean;
  risingBg?: boolean;
  step?: number;
  trackVariant?: TrackVariant;
}

const getValue = (value?: string | number | readonly string[]) => {
  if (Array.isArray(value)) {
    return [+value[0], +value[1]]
  } else {
    if (value) return +value;
  }
};

const Slider: React.FC<SliderProps> = (props: SliderProps) => {
  const { input, max, min, step, trackVariant } = props;
  const className = cn("Slider", props.className, {
    "Slider--risingBg": props.risingBg,
  })

  return (
    <ReactSlider
      value={getValue(input.value)}
      defaultValue={getValue(input.defaultValue)}
      onChange={input.onChange as any}
      className={className}
      max={max}
      min={min}
      step={step || 1}
      trackClassName={trackVariant ? `Slider-track--${trackVariant}` : "Slider-track"}
      thumbClassName="Slider-thumb"
    />
  )
}

export default Slider
